var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    role: "img",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title-sync"
  }, "Manage checkout and order sync") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title-sync"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6h15l-1.5 9H8.5L6 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 19,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h.01",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a4 4 0 00-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8l1.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13a4 4 0 01-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13l1.5 1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.93bcb59fd3042b2415c8df171850582c.svg";
export { ForwardRef as ReactComponent };